import { Grid, Paper, Typography } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import laqusImf from 'assets/laqus-imf-digital-1x.png';
import ReCAPTCHA from 'react-google-recaptcha';
import { RouterState } from 'common/genericTypes';
import { ComponentLoader } from 'components/loader';
import { Button, MdSpace, SmSpace, TextButton, TextField } from 'm2m.components';
import RequestNovaSenha from 'pages/login/requestNovaSenha';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from 'store';
import { loginAuth } from 'store/modules/auth';
import { deveUsarSsoLaqus } from 'utils/politicaAcessoSsoLaqus';
import { validaEmail } from 'utils/validation';
import { useBaseStyles } from './baseStyle';
import EscolherFuncao from './escolherFuncao';
import { addAlert } from 'store/modules/snackBar';

const mapStateToProps = (state: RootState) => ({
  isAuth: state.auth.isAuth,
  usuarioApi: state.usuarioApi,
});

const mapDispatchToProps = { loginAuth };

const publicRoutes = ['/login', '/new-user', '/nova-senha'];

const RESTRINGIR_ACESSO_SSO_LAQUS = process.env.REACT_APP_RESTRINGIR_ACESSO_SSO_LAQUS !== 'false';

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const Login: React.FC<Props> = (props) => {
  const { loginAuth, usuarioApi, isAuth } = props;
  const classes = useBaseStyles();
  const dispatch = useDispatch();

  const location = useLocation<RouterState>();
  const history = useHistory();
  const { from } = location.state || { from: { pathname: '/aprovacoes' } };

  const captchaRef = useRef<ReCAPTCHA>(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const [email, setEmail] = useState<string>('');
  const [senha, setSenha] = useState<string>('');
  const [captchaToken, setCaptchaToken] = useState<string>(process.env['REACT_APP_SITE_KEY'] ?? '');

  const [errorMsg, setErrorMsg] = useState<string>('');
  const [requestNovaSenha, setRequestNovaSenha] = useState<boolean>(false);

  const [loading, setLoading] = useState<boolean>(false);

  const trySso = () => {
    try {
      const idpToken = sessionStorage.getItem('idpToken');
      if (idpToken) {
        handleLogin(idpToken);
      }
    }
    catch (error) {
      console.error("Error trying SSO: ", error);
    }
  }

  useEffect(() => {
    trySso();
  }, []);

  const handleLogin = async (idpToken?: string) => {    
    try {
      //const consultoresList = await usuarioApi.getConsultoreslist(dispatch, email);
      //if (!consultoresList.isConsultor) {
        setLoading(true);
        const result = await usuarioApi.loginAuth(dispatch, { email, senha, captchaToken, idpToken });
        loginAuth({ usuario: { ...result, participanteFuncaoUsuarioId: '' }, token: result.token });
        setEmail('');
        setSenha('');
        setActiveStep(1);
        return;
      //}
      //handleBlackListValidation();
    } catch (error: any) {
      captchaRef?.current?.reset();
      if (idpToken) sessionStorage.removeItem('idpToken');
      if (!error?.response) {
        setErrorMsg(error.response.message);
        console.log(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBlackListValidation = async () => {
    try {
      dispatch(
        addAlert({
          message: 'O seu cadastro foi realizado com sucesso. Para efetuar o acesso, iremos te redirecionar automaticamente para a pagina de login fasttrack.prod.cloud.laqus.com.br',
          severity: 'success',
        })
      );

      setTimeout(() => {
        window.open('https://fasttrack.prod.cloud.laqus.com.br/api/auth/signin?callbackUrl=https%3A%2F%2Ffasttrack.prod.cloud.laqus.com.br%2F', '_blank');
      }, 5000);
    } catch (error) {
      console.error('Erro ao lidar com o redirecionamento:', error);
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (RESTRINGIR_ACESSO_SSO_LAQUS && deveUsarSsoLaqus(email)) {
      history.push('/sso');
      return;
    }

    handleLogin();
  };

  const handleSolicitarAcesso = () => {
    history.push('/no-auth/cadastro/participante');
  };

  useEffect(() => {
    if (isAuth) {
      if (publicRoutes.some((path) => from.pathname.includes(path))) history.replace({ pathname: '/aprovacoes' });
      else history.replace(from);
    }
  }, [isAuth, history, from]);

  const onCaptchaChange = (token: string | null) => {
     setCaptchaToken(token ?? '');
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ margin: '40px 0' }}>
          <Paper className={classes.paper}>
            {requestNovaSenha ? (
              <RequestNovaSenha onGetBack={() => setRequestNovaSenha(false)} />
            ) : activeStep === 0 ? (
              <Grid container justify="center">
                <Grid item>
                  <img src={laqusImf} alt="Logo Laqus IMF digital" />
                </Grid>
                <Grid item sm={12}>
                  <MdSpace />
                  <Typography align="center" variant="h2">
                    {`Seja bem-vindo!`}
                  </Typography>
                  <MdSpace />
                  <Typography align="center" variant="body2">
                    {`Ficamos felizes em oferecer o maior serviço de tecnologia em depósito de ativos.`}
                  </Typography>
                  <MdSpace />
                  {email && !validaEmail(email) && (
                    <>
                      <div style={{ display: 'flex' }}>
                        <Error style={{ marginRight: 10 }} color="error" />
                        <Typography variant="body2" color="error">{`Digite um e-mail válido.`}</Typography>
                      </div>
                      <SmSpace />
                    </>
                  )}
                  {errorMsg && (
                    <>
                      <div style={{ display: 'flex' }}>
                        <Error style={{ marginRight: 10 }} color="error" />
                        <Typography variant="body2" color="error">
                          {errorMsg}
                        </Typography>
                      </div>
                      <SmSpace />
                    </>
                  )}
                </Grid>
                <Grid item sm={12}>
                  <form onSubmit={handleSubmit}>
                    <TextField label="E-mail" required value={email} onChange={(value) => setEmail(value)} />
                    <SmSpace />
                    <TextField
                      label="Senha"
                      type="password"
                      required
                      value={senha}
                      onChange={(value) => setSenha(value)}
                    />
                    <MdSpace />
                    { <ReCAPTCHA
                      sitekey={process.env['REACT_APP_SITE_KEY'] ?? ''}
                      onChange={onCaptchaChange}
                      ref={captchaRef}
                    />}
                    <MdSpace />
                    <Grid container alignItems="center" justify="space-between">
                      <Grid item>
                        <TextButton
                          onClick={() => setRequestNovaSenha(true)}
                          style={{ padding: '0 0 5px 0', borderBottom: '1px solid #00E08E', borderRadius: 0 }}
                        >
                          {`Esqueci Minha Senha`}
                        </TextButton>
                      </Grid>
                      {/* <Grid item>
                        <TextButton
                          onClick={handleSolicitarAcesso}
                          style={{ padding: '0 0 5px 0', borderBottom: '1px solid #00E08E', borderRadius: 0 }}
                        >
                          {`Solicitar Acesso`}
                        </TextButton>
                      </Grid> */}
                      {loading && (
                        <Grid item>
                          <ComponentLoader loaderRelativePosition />
                        </Grid>
                      )}
                      <Grid item>
                        <Button
                          disabled={loading}
                          type="submit"
                          variant="contained"
                          color="primary"
                          style={{ margin: '0', padding: '16px 60px' }}
                          data-testId="btnEntrar"
                        >
                          {'Entrar'}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            ) : (
              <EscolherFuncao />
            )}
          </Paper>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
